import React from 'react'
import * as d3 from "../d3.modified.js"
import Utils from '../Utils'
import Indicators from './Indicators'

export default class LabelNode extends React.PureComponent {
    constructor(props) {
        super(props)
        // this.isJustClickNotDrag = false
        this.props.nodeItem.refs = {}
        this.props.nodeItem._jsx = {
            styleSelect: this.styleSelect,
            styleDeselect: this.styleDeselect,
            styleMove: this.styleMove,
            styleResize: this.styleResize,
            styleFade: this.styleFade,
            styleLinked: this.styleLinked,
            destyleLinked: this.destyleLinked,
        }

        let node = this.props.nodeItem

        this.state = {
            indicatorObj: {
                x: 0,
                y: node.height*0.5+35,
                _c: node.comments,
                _l: node.properties.url.length,
                _f: node.properties.files.length,
            }
        }
    }

    styleLinked = () => {
        var node = this.props.nodeItem
        this.props.enqueueClassChange({
            elem: node.refs.background,
            class: 'linkedto',
            val: true,
        })
    }

    destyleLinked = () => {
        var node = this.props.nodeItem
        this.props.enqueueClassChange({
            elem: node.refs.background,
            class: 'linkedto',
            val: false,
        })
    }


    componentWillReceiveProps(nextProps) {
        let node = nextProps.nodeItem
        this.setState({
            indicatorObj: {
                ...this.state.indicatorObj,
                _c: node.comments,
                _l: node.properties.url.length,
                _f: node.properties.files.length,
            }
        })
    }

    componentDidMount() {
        var node = this.props.nodeItem

        if (node._selectionId!==-1) {
            this.styleSelect()
        }

        this.styleResize()

        const _step = 10

        node.refs.holder
            .transition()
                .duration(500)
                .style('opacity', 1)

        this.position = undefined;
        if (this.props.edit) {
            node.refs.resizer.call(d3.drag()
                .on('start', ()=>{
                    node.resizeData = {
                        width: node.width,
                        height: node.height,
                        x: d3.event.x,
                        y: d3.event.y
                    }
                    if (node.refs.nameDOM) {
                        this.minWidth = node.refs.nameDOM.getBBox().width
                    } else {
                        this.minWidth = 10
                    }
                    this.props.clickHandler(node, false)
                })
                .on('drag', ()=>{
                    let oldDim = {w: node.width, h: node.height}
                    var newWidth = (d3.event.x-node.resizeData.x) + node.resizeData.width
                    if (newWidth>this.minWidth && newWidth<900) {
                        if (this.props.keyPressDict.grid) {
                            node.width = Math.floor(newWidth/_step)*_step
                        } else {
                            node.width = newWidth
                        }
                    }
                    var newHeight = (d3.event.y-node.resizeData.y) + node.resizeData.height
                    if (newHeight>20 && newHeight<800) {
                        if (this.props.keyPressDict.grid) {
                            node.height = Math.floor(newHeight/_step)*_step
                        } else {
                            node.height = newHeight
                        }
                    }
                    this.styleResize()
                    this.setState({
                        indicatorObj: {
                            // x: node.width*0.5,
                            ...this.state.indicatorObj,
                            y: node.height*0.5+35,
                        }
                    })
                    // this.props.dragHandler((node.width-oldDim.w)*0.5, (node.height-oldDim.h)*0.5)
                    this.props.resizeHandler(node.width, node.height, node.id)
                })
                .on('end', ()=>{
                    //this.props.dragEndHandler()
                    this.props.resizeEndHandler()
                })
            )
            node.refs.holder.call(d3.drag()
                .on('start', ()=>{
                    this.position = {x:d3.event.x, y:d3.event.y}
                    this.props.hideCtxMenus()

                    // <grided>
                    this.startDragMPosX = d3.event.x
                    this.startDragMPosY = d3.event.y
                    this.startDragPosX = node.x
                    this.startDragPosY = node.y
                    // </grided>

                    this.props.dragStartHandler()
                })
                .on('drag', ()=>{
                    node.refs.holder.classed('moving', true)
                    if (node._selectionId === -1) {
                        this.props.clickHandler(node, true)
                    }
                    if ((!this.props.keyPressDict.link || (this.props.keyPressDict.link && node._selectionId!==-1)) && (!this.props.keyPressDict.ctrl || node._selectionId !== -1)) {
                        // <grided>
                        if (this.props.keyPressDict.grid) {
                            let x = this.startDragPosX + (d3.event.x-this.startDragMPosX)-node.width*0.5
                            let y = this.startDragPosY + (d3.event.y-this.startDragMPosY)-node.height*0.5
                            x = parseInt((x+_step/2)/_step)*_step
                            y = parseInt((y+_step/2)/_step)*_step

                            let dx = x-node.x+node.width*0.5
                            let dy = y-node.y+node.height*0.5
                            this.props.dragHandler(dx, dy)
                        } else {
                        // </grided>
                            this.props.dragHandler(d3.event.dx, d3.event.dy)
                        }
                    }
                })
                .on('end', ()=>{
                    node.refs.holder.classed('moving', false)
                    let newPosition = {x:d3.event.x, y:d3.event.y}
                    if ((newPosition.x !== this.position.x) || (newPosition.y !== this.position.y) ) {
                        this.props.dragEndHandler()
                    }
                })
            )
        }

        node.refs.holder
            .on('mouseenter', ()=>{
                this.props.highlightConnections(node)
                if (this.props.keyPressDict.link) {
                    if (this.props.canCreateLink(node)) {
                        node.refs.holder.classed('linkage-can', true)
                    } else {
                        node.refs.holder.classed('linkage-cannot', true)
                    }
                }
            })
            .on('mouseleave', ()=>{
                this.props.dehighlightConnections(node)
                if (this.props.keyPressDict.link) {
                    node.refs.holder.classed('linkage-can', false)
                    node.refs.holder.classed('linkage-cannot', false)
                }
            })

        node.refs.holder
            .on("click", ()=>{
                if (this.props.keyPressDict.link && this.props.edit) {
                    this.props.createLink(node)
                } else {
                    this.props.clickHandler(node)
                }
                d3.event.stopPropagation()
            }).on("dblclick", ()=>{
                node.properties.url.forEach(url=>{
                    window.open((url.href.substr(0,4)==='http'?'':'//')+url.href, '_blank');
                })
                d3.event.stopPropagation()
            })

        
    }

    styleResize = () => {
        var node = this.props.nodeItem

        var hasTitle = (node.properties.title!=='')

        if (node.refs.nameDOM) {
            this.minWidth = node.refs.nameDOM.getBBox().width
            if (node.width<this.minWidth) {
                node.width = this.minWidth
            }
        }

        var _ = (a,b,c) => {this.props.enqueueAttrChange({elem:a,attr:b,val:c})}

        _(node.refs.shadow, 'width', node.width+30)
        _(node.refs.shadow, 'height', node.height+30)
        _(node.refs.shadow, 'transform', `translate(${-node.width/2-15} ${-node.height/2-15})`)
        _(node.refs.background, 'width', node.width+30)
        _(node.refs.background, 'height', node.height+30)
        _(node.refs.background, 'transform', `translate(${-node.width/2-15} ${-node.height/2-15})`)

        if (hasTitle) {
            _(node.refs.name, 'transform', `translate(0 ${-node.height/2+15})`)
        }
        _(node.refs.description, 'width', node.width)
        if (hasTitle) {
            _(node.refs.description, 'height', node.height-30<0?0:node.height-30)
            _(node.refs.description, 'transform', `translate(${-node.width/2} ${-node.height/2+30})`)
        } else {
            _(node.refs.description, 'height', node.height)
            _(node.refs.description, 'transform', `translate(${-node.width/2} ${-node.height/2})`)
        }

        _(node.refs.resizer, 'x', node.width/2+5)
        _(node.refs.resizer, 'y', node.height/2+5)
    }

    componentDidUpdate() {
        const diffColors = {
            none: "#fff",
            yellow: "#FFFFE6",
            green: "#E6FFED",
            red: "#FFEEF0"
        }

        var node = this.props.nodeItem
        this.props.enqueueStyleChange({
            elem: node.refs.background,
            prop: 'fill',
            val: node._compareType?diffColors[node._compareType]:node.properties.color
        })
        this.styleResize()
    }

    styleMove = () => {
        var node = this.props.nodeItem
        this.props.enqueueAttrChange({
            elem: node.refs.holder,
            attr: 'transform',
            val: `translate(${node.x} ${node.y})`
        })
    }

    styleSelect = () => {
        var node = this.props.nodeItem
        this.props.enqueueClassChange({
            elem: node.refs.background,
            class: 'active',
            val: true,
        })
    }

    styleDeselect = () => {
        var node = this.props.nodeItem
        this.props.enqueueClassChange({
            elem: node.refs.background,
            class: 'active',
            val: false,
        })
    }

    styleFade = () => {
        this.props.nodeItem.refs.holder
            .transition()
                .duration(400)
                .style('opacity', 0)
    }

    render() {
        var node = this.props.nodeItem

        const diffColors = {
            none: "#fff",
            yellow: "#FFFFE6",
            green: "#E6FFED",
            red: "#FFEEF0"
        }

        const {display, ...rest} = node.properties._render['description']

        let descStyle = {
            fontSize: rest.fontSize,
            fontStyle: rest.fontStyle,
            fontWeight: rest.fontWeight,
            color: rest.fill,
            lineHeight: parseInt(rest.fontSize)*1.4+'px',
        }

        return (
            <g
                className="node-holder node-superref-holder"
                transform={`translate(${node.x} ${node.y})`}
                ref={c=>node.refs.holder=d3.select(c)}
                opacity="0"
            >
            {/* BACKGROUND */}
                <rect
                    className="node-superref-shadow"
                    width={node.width}
                    height={node.height}
                    x="1.5"
                    y="1.5"
                    rx="3"
                    ry="3"
                    ref={c=>node.refs.shadow=d3.select(c)}
                />
                <rect
                    className="node-superref-background"
                    rx="3"
                    ry="3"
                    id={`N_${node.id}`}
                    ref={c=>node.refs.background=d3.select(c)}
                    style={{fill: node._compareType?diffColors[node._compareType]:node.properties.color}}
                />
            {/* FIELDS */}
                {
                    (node.properties.title!=='')
                        ?   <text
                                className="node-label-name"
                                textAnchor="middle"
                                alignmentBaseline="baseline"
                                ref={c=>{node.refs.name=d3.select(c); node.refs.nameDOM=c}}
                                transform={`translate(0 ${-node.height/2+15})`}
                                style={node.properties._render['title'] || {}}
                            >{node.properties.title}</text>
                        : null
                }
                <foreignObject x="0" y="0" width={node.width} height={node.height} ref={c=>node.refs.description=d3.select(c)}>
                    <div
                        className={`node-label-description`} id={`N_${node.id}_d`}
                        style={descStyle}
                    >
                        {
                            Utils.parseLinks(node.properties.description).map(
                                part => (part.isLink)
                                    ? ((part.val.substring(0,4)==='http')
                                            ? <a key={part.val} href={part.val} rel="noopener">{part.val}</a>
                                            : <a key={part.val} href={'http://'+part.val} rel="noopener">{part.val}</a>
                                    ) : part.val
                            )
                            // window.markdeep.format(node.properties.description, false)
                        }
                    </div>
                </foreignObject>
            {/* RESIZE */}
                <rect
                    display={this.props.edit ? "default" : "none"}
                    x={node.width-10}
                    y={node.height-10}
                    width="10"
                    height="10"
                    className="node-superref-resizer"
                    ref={c=>node.refs.resizer=d3.select(c)}
                />
                <Indicators
                    {...this.state.indicatorObj}
                    ref={c=>node.refs.indicator=c}
                />
            </g>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/nodes/SuperLabelNode.js